var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckLg = function SvgCheckLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "none",
    stroke: "#fff",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m1.667 5 4.15 3.555 8.294-7.11"
  })));
};
export default SvgCheckLg;